import { useState, useEffect } from 'react';

import Error404Img from '../../assets/images/Error404.png';

export default function Error404() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const imgWidth = windowWidth > 768 ? "500px" : "80%";
    const fontSize = windowWidth > 768 ? "2.5rem" : "1.5rem";
    const marginTopImg = windowWidth > 768 ? "-150px" : "-50px";
    const marginTopText = windowWidth > 768 ? "-25px" : "-10px";

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100%",
                padding: "0 10px",
                boxSizing: "border-box",
                textAlign: "center",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <img
                    src={Error404Img}
                    alt="Error404"
                    style={{
                        marginTop: marginTopImg,
                        width: imgWidth,
                        maxWidth: "100%",
                        height: "auto",
                    }}
                />
                <p
                    style={{
                        marginTop: marginTopText,
                        fontSize: fontSize,
                        color: "#FFFFFF",
                    }}
                    className="worldwide"
                >
                    Eroare! Pagina căutată nu există!
                </p>
            </div>
        </div>
    );
}